import devConfig from './dev';
import prodConfig from './prod';

const env = process.env.NODE_ENV;
const envMap = {
  development: devConfig,
  production: prodConfig,
};

/**
 *
 * env，构建环境，webpack注入的全局常量 process.env.NODE_ENV，传入值为 'development' / 'production'
 * API_ENV, API环境，webpack注入的全局常量 API_ENV，传入值为 undefined / 'production'
 *
 * 说明：
 * 1. 优先取 API_ENV 传入的后台接口环境常量，取不到再取构建环境常量
 * 2. 本地开发可以调正式环境API接口进行测试，构建环境 = development & API环境 = production
 *
 */
const module = envMap[API_ENV] || envMap[env] || envMap.production;

if (env === 'development') {
  console.log('----------------------------------');
  console.log('构建环境：', env);
  console.log('构建版本：', BUILD_VERSION);
  console.log('API环境：', API_ENV);
  console.log('API配置：', module);
  console.log('----------------------------------');
}

export const config = module;
